<template>
  <div class="home">
   <div class="dddd">
   	 <div id="myCarousel" class="carousel slide" data-interval='4000'>
    <!-- 轮播（Carousel）指标 -->
    <ol class="carousel-indicators">
        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
        <li data-target="#myCarousel" data-slide-to="1"></li>
        <li data-target="#myCarousel" data-slide-to="2"></li>
        <li data-target="#myCarousel" data-slide-to="3"></li>
        <li data-target="#myCarousel" data-slide-to="4"></li>
    </ol>   
    <!-- 轮播（Carousel）项目 -->
    <div class="carousel-inner">
        <div class="item active">
        		<router-link  :to = 'vuelink[0].vuelink'>
            <img src="../../static/img/banner_01.jpg" alt="First slide">
          	</router-link>
        </div>
        <div class="item">
        		<router-link  :to = 'vuelink[1].vuelink'>
            <img src="../../static/img/banner_02.jpg" alt="Second slide">
            </router-link>
        </div>
        <div class="item">
        		<router-link  :to = 'vuelink[2].vuelink'>
            <img src="../../static/img/banner_03.jpg" alt="Third slide">
            </router-link>
        </div>
        <div class="item">
        		<router-link  :to = 'vuelink[3].vuelink'>
            <img src="../../static/img/banner_04.jpg" alt="Third slide">
            </router-link>
        </div>
        <div class="item">
            <img src="../../static/img/banner_05.jpg" alt="Third slide">
        </div>
    </div>
    <!-- 轮播（Carousel）导航 -->
    <a class="carousel-control left" href="#myCarousel" 
        data-slide="prev">&lsaquo;
    </a>
    <a class="carousel-control right" href="#myCarousel" 
        data-slide="next">&rsaquo;
    </a>
		</div>
   </div>
   <div class="hserver">
   		<div class="server-tit">
   			<h4>服务领域</h4>
   		</div>
   		<div class="server-content">
   			<div class="content-detail" v-for="(item, index) in img">
	   				<div class="limitimg">
	   					<img :src="item.imgsrc" class="backimg"/>
	   					<transition name="slide-fadey">
	   					<img :src="imgicon[index].imgsrc" class="iconimg" v-show="show"/>
	   					</transition>
	   					
	   					<transition name="slide-fadey">
	   					<div class="imgdetail" v-show="show">
	   						<h3>{{imgicon[index].detailtit}}</h3>
	   						<p>{{imgicon[index].detailen}}</p>
	   					</div>
	   					</transition>
	   				</div>
   				
   			</div>
   		</div>
   </div>
   <div class="solvecase">
   		<div class="server-tit">
   			<h4>专业解决方案</h4>
   		</div>
   		  <el-carousel :interval="4000" type="card" height="600px" @change = 'getin($event)'>
			    <el-carousel-item  v-for="(solve, index) in solvelist" :key="index" :class="{solvesmaitem : solve.id != swipeindex}">
			    	<div class="solve-topop" v-bind:class="{solvesmatop : solve.id != swipeindex}">
			    		<img v-if="solve.id != swipeindex" :class="{noneimg : solve.id != swipeindex}" :src="solve.imgsrc"/>
				    	<div class="solsma-tit" v-bind:class="{noneac : solve.id != swipeindex}">
				    		<h3 v-bind:class="{noneach3 : solve.id != swipeindex}">{{ solve.tit }}</h3>
				    	</div>
				    	<div class="solsma-icon" v-bind:class="{noneacic : solve.id != swipeindex}">
				    		<img v-if="solve.id == swipeindex" :src="solve.imgsrc"/>
				    		<p v-bind:class="{noneacp : solve.id != swipeindex}">{{solve.content}}</p>
				    	</div>
			    	</div>
			    	<div class="solsma-bottom">
			    		<p><b>{{solve.fottit}}</b></p>
			    		<p>{{solve.fotstit}}</p>
			    		<p><b>{{solve.fotttit}}</b></p>
			    		<p>{{solve.fotftit}}</p>
			    	</div>
			    	<div class="solsma-footer">
			    		<router-link :to = 'falink[0].falink'>
			    		  <el-button @click = 'gotop()'>MORE</el-button>
							</router-link>
			    	</div>
			    </el-carousel-item>
			  </el-carousel>
   </div>
   <div class="product">
   		<div class="server-tit">
   			<h4>我们的产品</h4>
   		</div>
   		<div class="pro-detail" >
   			<div class="detail-pro" v-for="(item , index) in detail" @mouseover.stop="getheight(item.id)" @mouseout.stop="outbac()" @click="topro(item.prolink)"> 
   				<img :src="item.imgsrc"/>
   				<transition name="slide-fade">
   				<div class="change-pro" v-show="bacshow == item.id">
   					<img class="pro-image" :src="iconb[index].imgsrc"/>
   					<div class="pro-p" :style="{width : width}">
   						<router-link to=''><p>{{iconb[index].content}}</p></router-link>
   					</div>	
   					<div class="back-pro" :style="{height : height}">	
   					</div>
   				</div>
   				</transition>
   				<transition name="slide-fadex">
   				<div class="change-pro" v-show="bacshow == 0 || bacshow != item.id">
   					<img class="pro-image" :src="iconb[index].imgsrc"/>
   					<div class="pro-line">
   					<h3>{{iconb[index].tit}}</h3>	
   					</div>
   					<div class="back-pro black" :style="{height : height}">
   					</div>
   				</div>
   				</transition>
   			</div>
   		</div>
   </div>
   <div class="news">
   	<div class="sanjiao">
   	</div>
   	<div class="newscon">
	   	<div class="comlist">
	   		<div class="comstit">
	   			<span>快速导航        &nbsp;&nbsp; INTRODUCTION</span>
	   		</div>
	   		<div class="comswindows">
	   			<div class="windowslist" v-for="win in windows" @click="routerto(win.imglink)">
	   				
	   				<img :src="win.imgsrc" class="winlist"/>
	   				<div class="comsbottom">
	   				<div class="com-p">
						{{win.winname}}				
	   				</div>
	   				<div class="com-bac">
	   				</div>
	   				
	   			</div>
	   			</div>
	   			
	   		</div>
	   	</div>
	   	<div class="newslist">
	   		<div class="comstit">
	   			<span>新闻中心        &nbsp;&nbsp; NEWS CENTER</span>
	   		</div>
	   		<div class="newsli">
	   			<ul>
	   				<li v-for="newsli in news"  @click="todetail(newsli.ID)">{{newsli.title}}
	   				<div class="lidata">
	   					{{newsli.createDate}}
	   				</div>
	   				</li>
	   			</ul>
	   		</div>
	   	</div>
   	</div>
   
   </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    	img : [
    	{id : 1 , imgsrc : 'static/img/data_03.jpg' ,imglink : '#'},
    	{id : 2 , imgsrc : 'static/img/data_02.jpg' ,imglink : '#'},
    	{id : 3 , imgsrc : 'static/img/data_01.jpg' ,imglink : '#'},
    	],
    	imgicon : [
			{id : 1 , imgsrc : 'static/img/sy3_03.png' ,imglink : '#' , detailtit : '系统集成' , detailen : 'System Integration'},
			{id : 2 , imgsrc : 'static/img/sy3_02-06.png' ,imglink : '#' , detailtit : '软件与数据服务' , detailen : 'Software and data services'},
			{id : 3 , imgsrc : 'static/img/sy3_01-09.png' ,imglink : '#' , detailtit : 'IT运维服务' , detailen : 'IT operation and maintenance service'},
    	],
    	vuelink : [
			{id : 1 , vuelink : '/TechnologyService/'},
			{id : 2 , vuelink : '/Solve/'},
			{id : 3 , vuelink : '/TechnologyService/'},
			{id : 4 , vuelink : '/TechnologyBusiness/'},
    	],
    	falink : [
			{id : 0 , falink : '/Solve/' + 1},
			{id : 1 , falink : '/Solve/' + 2},
			{id : 3 , falink : '/TechnologyField/'},
			{id : 3 , falink : '/TechnologyService/'},
			{id : 4 , falink : '/TechnologyService/'},
    	],
    	detail :[
    	{id : 1 , imgsrc : 'static/img/industry03.jpg' , prolink : '/Product/' + 2},
    	{id : 2 , imgsrc : 'static/img/industry02.jpg' , prolink : '/Product/' + 4},
    	{id : 3 , imgsrc : 'static/img/industry01.jpg' , prolink : '/Product/' + 3},
    	{id : 4 , imgsrc : 'static/img/industry04.jpg' , prolink : '/Product/' + 7},
    	],
    	iconb : [
    	{id : 1 , imgsrc : 'static/img/xiangmu.png' , tit : '公共资源业务系统' , content : '公共资源业务系统是专门针对公共资源交易中心的业务进行开发的综合管理系统， 系统由统一的管理平台与工程交易、土地与矿业权交易、政府采购、产权交易等主要业务子系统组成。'},
    	{id : 2 , imgsrc : 'static/img/zichan.png' , tit : '新零售业务系统' , content : '系统以中小企业为服务对象，从实现中小企业内部信息管理出发，对接“淘宝”类的大平台，做到充分利用平台资源的同时发挥中小企业的自身灵活性， 切实帮助中小企业面对“新零售”的诸多挑战。'},
    	{id : 3 , imgsrc : 'static/img/zhiyuan.png' , tit : '智慧旅游综合业务系统' , content : '智慧旅游综合业务系统提供针对旅游行业的综合业务管理；包括门户、OA、资产管理、园林专项业务、旅游专项管理等模块。'},
    	{id : 4 , imgsrc : 'static/img/110.png' , tit : '智能综合指挥平台' , content : '系统采用了网络、多媒体、物联网等多种技术，具有智能化、可视化、精确化的统一综合指挥功能，由（1）GIS地图监视（2）视频监控与安全警报（3） 车辆通行监控与交通疏导指挥（4）人流量监控与预警管理（5）统一信息发布（6）智能防火警报（7）环境监测系统（8）GPS北斗定位系统（9）视频会议（10） 数字广播系统等专业模块与（11）统一指令系统组成。通过对各子系统功能的有机结合实现统一指挥与调度工作，满足景区、小区、商业综合体、工业园区、学校、 村镇等区域公共安全的综合指挥工作。'},
    	],
    	windows : [
    	{id : 1 , imgsrc : 'static/img/quick-nav-about.jpg' , winname : '公司简介' , imglink : '/AboutcomInfo/'},
    	{id : 2 , imgsrc : 'static/img/quick-nav-wenhua.jpg' , winname : '企业文化' , imglink : '/AboutcomCulture/'},
    	{id : 3 , imgsrc : 'static/img/quick-nav-zhaopin.jpg' , winname : '诚聘英才' , imglink : '/Zhaopin'},
    	{id : 4 , imgsrc : 'static/img/quick-nav-contact.jpg' , winname : '联系我们' , imglink : '/Contactu'},
    	],
    	news : [
    	{ID : 1 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	{ID : 2 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	{ID : 3 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	{ID : 4 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	{ID : 5 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	{ID : 6 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	{ID : 7 , title : '广东思程科技有限公司是一家专业的IT解决方案服务商。' , imglink : '#' , createDate : '2017-10-10'},
    	],
    	solvelist :[
    	{id : 0 , imgsrc : 'static/img/zhlysml.png' , tit : '智慧旅游' , content : '通过互联网/移动互联网，借助便携的终端上网设备，主动感知旅游资源、旅游经济、旅游活动、旅游者等方面的信息及时发布，让人们能够更及时了解这些信息。',fottit : '游客体验',fotstit : '方便游客通过平台对景区进行了解，提高游客在游玩过程中的体验',fotttit : '景区管理',fotftit : '运用科技智能手段进行全面管理，提高景区服务，加强景区安全，打造优质景区'},
    	{id : 1 , imgsrc : 'static/img/zhfysml.png' , tit : '智慧法院' , content : '以信息化推进人民法院审判体系和审判能力现代化 ，服务国家治理体系和治理能力现代化',fottit : '诉讼人',fotstit : '转变角色，以服务人身份向诉讼人提供专业的服务，如诉讼进程与结果信息查询',fotttit : '律师',fotftit : '遵循三公开原则，对相关案件资料提供公开信息对接服务，对律师提供网上业务办理支持。'},
    	{id : 2 , imgsrc : 'static/img/ggzysml.png' , tit : '公共资源交易一体化' , content : '建立统一公共资源交易平台,更大限度地激活市场要素，整合资源，加强市场监管、降低交易成本。',fottit : '全程无纸',fotstit : '标书全电子化，大大加快信息的流动速度，同时节约大量纸张',fotttit : '全程共享',fotftit : '实现场地、网络、服务机构等资源共享；评标专家信息、单位诚信记录共享'},
    	{id : 3 , imgsrc : 'static/img/lssml.png' , tit : '律师行业业务' , content : '作为我司自主研发的产品，旨在满足律师行业的业务需求，提供更畅快的办公体验、更有效的管理模式、以及更智能的业务员流程。',fottit : '畅快的办公体验',fotstit : '随时随地办公，操作简单、易用上手，支持在线文档阅读',fotttit : '智能的业务流程',fotftit : '智能代办定时提醒业务，进程直接展示，可定制化流程管理对防伪系统对接。'},
    	{id : 4 , imgsrc : 'static/img/syxls.png' , tit : '新零售' , content : '即企业以互联网为依托，通过运用大数据、人工智能等先进技术手段，对商品的生产、流通与销售过程进行升级改造，进而重塑业态结构与生态圈，并对线上服务、线下体验以及现代物流进行深度融合的零售新模式。',fottit : '沉淀数据，高效管理会员',fotstit : '全方位采集消费者数据: 充分利用线下门店流量，将到店顾客转化为线上会员。',fotttit : '快速搭建全渠道零售体系',fotftit : '用一套方案搭建全渠道零售体系拒绝多个业务系统相互割裂而造成的“信息孤岛”。'},
    		
    	],
    	show : false,
    	height: 'auto',
    	bacshow : 0,
    	top : '0px',
    	width : '300px',
		swipeindex :　0,
		onOff: true
    }
  },
  metaInfo: {
	title: '广东思程科技有限公司',
	meta: [{                
		name: 'keyWords',
		content: '广东思程，思程科技，思程，交易系统，见证系统，系统集成，软件与数据服务'
	},
	{
		name: "description",
		content: "广东思程科技有限公司是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。",
	},]
  },
  mounted(){
    this.scor();
    this.getnews();
  },
  watch:{
  	show : function(){
  		this.gotheight()
  	}
  },
  methods:{
		scor(){
			var that = this;
				$(document).scroll(function(){
            		var htop = $(document).scrollTop();
            		if(htop>=200 & htop<750 ){
            			that.show = true
            		}else if(htop < 200 || htop >= 750){
            			that.show = false
            		}
            		
            	});
	 	},
	 	gotheight(){
	 			var htop = $(document).scrollTop();
   				var top =  $('.detail-pro')[0].clientHeight - 100 +'px'
   				this.top = top
   				var width =  $('.detail-pro')[0].clientWidth * 0.8 +'px'
   				this.width = width
	 				var he = $('.detail-pro')[0].clientHeight + 'px'
   				this.height = he
	 	},
	 	getheight(index){
			if(this.onOff) {
				console.log(1)
				this.onOff = false
				var that = this
	 			that.bacshow = index
			}
	 		
	 	},
	 	outbac(){
			 
			 if(!this.onOff) {
				 this.onOff = true
				//  this.bacshow = 0
			 }
	 			
	 	},
	 	getin(val){
	 		this.swipeindex = val
	 	},
	 	gotop(){
				window.scrollTo(0,0)
		},
	 	getnews(){
     				this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			        for(var i=0 ; i<response.body.length ; i++){
			        	var data =  response.body[i].createDate;
			        	response.body[i].createDate = data.substr(0,10)
			        }
			        this.news = response.body;
			      })
     		},
    todetail(id){
    			this.gotop();
     			this.$router.push('/Newsdetail/'+id);
     		},
    routerto(linkt){
    	this.gotop();
     	this.$router.push(linkt);
    },
    topro(linkt){
    	this.gotop();
     	this.$router.push(linkt);
    }
	},
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.home{
	width: 100%;
	overflow: hidden;
}
.dddd{
	width: 100%;
}
.home .carousel-control{
	opacity: .3;
	align-items: center;
  display: flex;
}
.home .carousel-inner>.item>a>img, .carousel-inner>.item>img {
    line-height: 1;
    width: 100%;
}
.home{
	position: relative;
	width: 100%;
}

.home .carousel-control{
		padding: 0 70px;
    font-size: 60px;
}

.home .hserver{
	width: 75%;
	position: relative;
	clear: both;
	margin: 0 auto;
}

.server-tit{
	width: 100%;
	position: relative;
	margin: 0 auto;
	clear: both;
	margin: 60px auto 50px;
}
.server-tit h4{
	font-size: 26px;
	font-weight: bolder;
	color: #333333;
}
.content-detail{
	display: inline-block;
	position: relative;
	width: 33%;
}
.content-detail img{
	width: 100%;
	height: 100%;
	transition: all 1.3s;
}
.server-content{
	margin-bottom: 90px;
}
.limitimg{
	width: 90%;
	height: 90%;
	overflow: hidden;
}
.comsbottom{
	text-align: center;
	margin: 0 auto;
	position: absolute;
	bottom: 0;
	left: 0;
	width:100%;
	padding: 5px 0;
}
.com-bac{
	background: #000000;
	opacity: .4;
	width: 90%;
  height: 30px;
  position: absolute;
  bottom: 0;
  z-index: 0;
}
.limitimg img.backimg:hover{
	transform: scale(1.3);
}
.limitimg img.iconimg{
	position: absolute;
	z-index: 3;
	width: 20%;
  height: 20%;
  top: 24%;
  left: 36%;
}
.imgdetail{
	position: absolute;
	z-index: 3;
	bottom: 60px;
	width: 90%;
}
.imgdetail h3, .imgdetail p{
	color: #fff;
}
.slide-fadey-enter-active {
    transition: all .3s ease;
}
.slide-fadey-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
/*.slide-fadey-enter, .slide-fadey-leave-to*/
.slide-fadey-enter, .slide-fadey-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(40px);
  opacity: 0;
}
.slide-fade-enter-active {
    transition: all .4s linear;
}
.slide-fade-leave-active {
    transition: all 0s  linear;
}
/*.slide-fadey-enter, .slide-fadey-leave-to*/
.slide-fade-enter, .slide-fadey-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(40px);
}
.slide-fadex-enter-active {
    transition: all .4s linear;
}
.slide-fadex-leave-active {
    transition: all 0  linear;
}
/*.slide-fadey-enter, .slide-fadey-leave-to*/
.slide-fadex-enter, .slide-fadex-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-40px);
}
.solvecase,.news{
	position: relative;
	clear: both;
	background: #e0e9f1;
	width: 100%;
	padding: 30px 0;
	margin: 0 auto;
}
.product{
	position: relative;
	clear: both;
	width: 100%;
	padding: 30px 0;
	margin: 0 auto;
}

.sanjiao{
	position: absolute;
	width: 100%;
	height: 30px;
	width: 30px;
	background: #FFFFFF;
	margin: 0 auto;
	left: 48%;
	top: -15px;
	transform: rotate(45deg);
}
.home .pro-detail{
	position: relative;
	width: 80%;
	clear: both;
	margin: 20px auto;
	text-align: center;
}
.detail-pro{
	position: relative;
	width: 49%;
	clear: both;
	display: inline-block;
	margin: 20px auto;
}
.detail-pro img{
	width: 85%;
}
.change-pro{
	position: absolute;
	display: inline-block;
	width: 85%;
}
.back-pro{
	position: absolute;
	display: inline-block;
	width: 100%;
	z-index: 4;
	left:-100%;
	background: #2f5be2;
	opacity: .8;
}

.black{
	position: absolute;
	display: inline-block;
	width: 100%;
	left:-100%;
	background: black;
	opacity: .2;
}
.detail-pro img.pro-image{
	  position: absolute;
    width: 90px;
    left: -60%;
    top: 50px;
    z-index: 5;
}
.pro-line{
	position: absolute;
	width: 50px;
	border-bottom: 5px solid #FFF;
	opacity: .8;
	border-radius: 10px;
	left: -18.5vw;
  top: 180px;
  z-index: 5;
}
.change-pro h3{
	position: absolute;
	color: #FFF;
	z-index: 5;
	width: 200px;
	left: -140%;
	top: 3vw;
}
.change-pro p{
	position: absolute;
	color: #FFF;
	z-index: 5;
	width: 80%;
  left: -27.5vw;
  font-size: 14px;
}
.comlist{
	position: relative;
	clear: both;
	display: inline-block;
	width: 48%;
	text-align: left;
}
.newslist{
	position: relative;
	clear: both;
	display: inline-block;
	width: 48%;
	text-align: left;
	float: right;
}
.newscon{
	position: relative;
	clear: both;
	width: 80%;
	margin: 0 auto;
}
.comstit{
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
	width: 90%;
}
.comstit span{
	font-size: 16px;
}
.comswindows{
	padding: 25px 2%;
	position: relative;
	clear: both;
}
.windowslist{
	width: 47%;
	position: relative;
	display: inline-block;
	clear: both;
	margin-bottom: 20px;
}
.windowslist img.winlist{
	width: 90%;
	position: relative;
}
.newsli{
	padding: 2% 0;
	position: relative;
}
.newsli li{
	list-style: none;
	line-height: 40px;
  border-bottom: 1px solid #ddd;
  width: 90%;
  margin: 0 ;
  font-size: 13px;
  position: relative;
  display: inline-block;
}
.newsli ul{
	overflow: hidden;
}
.lidata{
	position: absolute;
	right: 0;
	display: inline-block;
	top: 0;
	color: #660000;
}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #fff;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #fff;
  }
  .solsma-tit{
  	position: relative;
  	clear: both;
  	height: 60px;
  	background: #0066ef;
  }
  .el-carousel__item .solsma-tit h3{
  	line-height: 60px;
  	color: #FFFFFF;
  	font-size: 18px;
  	font-weight: 600;
  	opacity: 1;
  }
  .solsma-icon{
  	position: relative;
  	padding-top:30px ;
  	
  }
  .solsma-icon p{
  	padding: 30px 15%;
  	color: #8c93a0;
  }
  .solsma-bottom{
  	padding: 10px 15%;
  	text-align: left;
  	position: relative;
  }
  .solsma-bottom p{
  	color: #8c93a0;
  }
  .solsma-bottom p b{
  	color: #555555;
  }
  
  .solsma-footer{
  	padding: 15px 15%;
  	position: relative;
  }
  .solvecase .el-carousel{
  	width: 70%;
    margin: 0 auto;
  }
  .pro-p{
  	margin: 0 auto;
  	top: 13vw;
  	position: absolute;
  }
  .com-p{
  	color: #FFFFFF;
  	z-index: 4;
  	width: 90%;
  	position: relative;
  }
  .solvecase .noneac{
  	background: none !important;
  	width: 100%;
  }
  .solvecase h3.noneach3{
  	color: #333333;
  }
  .solvecase p.noneacp{
  	margin: 0px 0 30px;
  	padding: 10px 15% 30px;
  }
  .solvesmatop{
  	background: #F0F4F8;
  }
  .solvecase img.noneimg{
  	padding-top: 50px;
  }
  .solvecase .noneacic{
  	padding-top: 0 !important;
  }
  .solvesmaitem{
  	/*transform: scale(0.93) !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue